export namespace TaxDocumentTypes {

    export const TaxDocumentType = Symbol("TaxDocumentType");
    export interface TaxDocumentType {
        [TaxDocumentType]: boolean;
    }

    export interface TaxDocumentTypeDto {
        $type: string;
        value: TaxDocumentTypeValueDto;
    }

    export interface TaxDocumentTypeValueDto {
        //
    }

    export function serializeTaxDocumentType(action: TaxDocumentType): TaxDocumentTypeDto {
        if (!action) {
            return null;
        }

        for (let refundType of refundTypes) {
            if (refundType.isInstanceOf(action)) {
                return {
                    $type: refundType.key,
                    value: refundType.serialize(action)
                };
            }
        }

        throw new Error("Invalid status type");
    }

    export function deserializeTaxDocumentType(dto: TaxDocumentTypeDto): TaxDocumentType {
        if (!dto) {
            return null;
        }

        for (let refundType of refundTypes) {
            if (refundType.key === dto.$type) {
                return refundType.deserialize(dto.value);
            }
        }

        throw new Error("Invalid status type");
    }

    export function getTaxDocumentTypeName(status: TaxDocumentType): string {

        for (let refundType of refundTypes) {
            if (refundType.isInstanceOf(status)) {
                return refundType.name;
            }
        }

        throw new Error("Invalid status type");
    }

    export function createTaxDocumentType(key: string): TaxDocumentType {

        for (let refundType of refundTypes) {
            if (refundType.key === key) {
                return refundType.create();
            }
        }

        throw new Error("Invalid refundType key");
    }



    export const TaxInvoiceTaxDocumentType = Symbol("TaxInvoiceTaxDocumentType");
    export interface TaxInvoiceTaxDocumentType extends TaxDocumentType {
        [TaxInvoiceTaxDocumentType]: boolean;
        TaxInvoiceId: string;
        InvoiceNumber: string;
    }

    export function isTaxInvoiceTaxDocumentType(val: TaxDocumentType): val is TaxInvoiceTaxDocumentType {
        return val && (val as TaxInvoiceTaxDocumentType)[TaxInvoiceTaxDocumentType] === true;
    }

    export interface TaxInvoiceTaxDocumentTypeValueDto extends TaxDocumentTypeValueDto {
        taxInvoiceId: string;
        invoiceNumber: string;
    }

    export const TaxInvoiceTaxDocumentTypeDefinition: TaxDocumentTypeDefinitionT<TaxInvoiceTaxDocumentType, TaxInvoiceTaxDocumentTypeValueDto> =
    {
        key: "TaxInvoice",
        name: "TaxInvoice",
        isInstanceOf: (refundType: TaxDocumentType) => isTaxInvoiceTaxDocumentType(refundType),
        create: (): TaxInvoiceTaxDocumentType => {
            return {
                [TaxDocumentType]: true,
                [TaxInvoiceTaxDocumentType]: true,
                TaxInvoiceId: null,
                InvoiceNumber: null
            };
        },
        serialize: (refundType: TaxInvoiceTaxDocumentType): TaxInvoiceTaxDocumentTypeValueDto => {
            return {
                taxInvoiceId: refundType.TaxInvoiceId,
                invoiceNumber: refundType.InvoiceNumber
            };
        },
        deserialize: function (this: TaxDocumentTypeDefinition, dto: TaxInvoiceTaxDocumentTypeValueDto) {
            const taxInvoice = this.create() as TaxInvoiceTaxDocumentType;
            taxInvoice.TaxInvoiceId = dto.taxInvoiceId;
            taxInvoice.InvoiceNumber = dto.invoiceNumber
            return taxInvoice;
        }
    };





    export const CreditNoteTaxDocumentType = Symbol("CreditNoteTaxDocumentType");
    export interface CreditNoteTaxDocumentType extends TaxDocumentType {
        [CreditNoteTaxDocumentType]: boolean;
        CreditNoteId: string;
        CreditNoteNumber: string;
    }

    export function isCreditNoteTaxDocumentType(val: TaxDocumentType): val is CreditNoteTaxDocumentType {
        return val && (val as CreditNoteTaxDocumentType)[CreditNoteTaxDocumentType] === true;
    }

    export interface CreditNoteTaxDocumentTypeValueDto extends TaxDocumentTypeValueDto {
        creditNoteId: string;
        creditNoteNumber: string;
    }

    export const CreditNoteTaxDocumentTypeDefinition: TaxDocumentTypeDefinitionT<CreditNoteTaxDocumentType, CreditNoteTaxDocumentTypeValueDto> =
    {
        key: "CreditNote",
        name: "CreditNote",
        isInstanceOf: (refundType: TaxDocumentType) => isCreditNoteTaxDocumentType(refundType),
        create: (): CreditNoteTaxDocumentType => {
            return {
                [TaxDocumentType]: true,
                [CreditNoteTaxDocumentType]: true,
                CreditNoteId: null,
                CreditNoteNumber: null
            };
        },
        serialize: (refundType: CreditNoteTaxDocumentType): CreditNoteTaxDocumentTypeValueDto => {
            return {
                creditNoteId: refundType.CreditNoteId,
                creditNoteNumber: refundType.CreditNoteNumber
            };
        },
        deserialize: function (this: TaxDocumentTypeDefinition, dto: CreditNoteTaxDocumentTypeValueDto) {
            const taxInvoice = this.create() as CreditNoteTaxDocumentType;
            taxInvoice.CreditNoteId = dto.creditNoteId;
            taxInvoice.CreditNoteNumber = dto.creditNoteNumber
            return taxInvoice;
        }
    };

    interface TaxDocumentTypeDefinition {
        key: string;
        name: string;
        isInstanceOf: (refundType: TaxDocumentType) => boolean;
        create: () => TaxDocumentType;
        serialize: (refundType: TaxDocumentType) => TaxDocumentTypeValueDto;
        deserialize: (dto: TaxDocumentTypeValueDto) => TaxDocumentType;
    }

    interface TaxDocumentTypeDefinitionT<T, TDto> extends Omit<TaxDocumentTypeDefinition, 'create' | 'serialize' | 'deserialize'> {
        create: () => T;
        serialize: (refundType: T) => TDto;
        deserialize: (dto: TDto) => T;
    }

    const refundTypes: TaxDocumentTypeDefinition[] = [
        TaxInvoiceTaxDocumentTypeDefinition,
        CreditNoteTaxDocumentTypeDefinition
    ]

}
